import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/Slices/busSlice';
import logo from '../../components/assets/logos/logo2.PNG';
import { FaHome } from 'react-icons/fa';

const TermsOfService = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentLanguage = useSelector(selectLanguage);
  const [isMobile, setIsMobile] = useState(false);

   useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: 'instant' 
      });
    }, []); 
  
    useEffect(() => {
      const checkScreenSize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      
      checkScreenSize();
      window.addEventListener('resize', checkScreenSize);
      
      return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

  useEffect(() => {
    const htmlElement = document.documentElement;
    const bodyElement = document.body;
    
    htmlElement.lang = currentLanguage;
    htmlElement.classList.remove('hindi-lang');
    bodyElement.classList.remove('hindi-lang');
    
    if (currentLanguage === 'hi') {
      htmlElement.classList.add('hindi-lang');
      bodyElement.classList.add('hindi-lang');
    }
    
    htmlElement.classList.add('font-transition');
    bodyElement.classList.add('font-transition');
    
    return () => {
      htmlElement.classList.remove('hindi-lang', 'font-transition');
      bodyElement.classList.remove('hindi-lang', 'font-transition');
    };
  }, [currentLanguage]);

  const getFontConfig = () => {
    if (currentLanguage === 'hi') {
      return {
      fontFamily: "'Noto Serif Devanagari', serif",


        fontWeight: 500,
        className: 'hindi-lang font-hindi'
      };
    }
    return {
   fontFamily: "'Noto Serif Devanagari', serif",


      fontWeight: 400,
      className: 'font-english'
    };
  };

  const fontConfig = getFontConfig();

  const handleBack = () => {
    navigate('/');
  };

  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      fontFamily: fontConfig.fontFamily,
      fontWeight: fontConfig.fontWeight,
      padding: isMobile ? '10px' : '0',
      overflowX: 'hidden',
      transition: 'font-family 0.3s ease, font-weight 0.3s ease'
    },
    header: {
      background: 'linear-gradient(135deg, #FFFDE7 0%, #FFF9C4 100%)',
      color: 'black',
      padding: isMobile ? '10px 20px' : '10px 40px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      borderBottom: '3px solid #ffeb3b'
    },
    headerContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px'
    },
    logoLink: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      textDecoration: 'none',
      color: 'black'
    },
    logoImage: {
      height: isMobile ? '45px' : '60px',
      width: 'auto',
      objectFit: 'contain',
      borderRadius: '8px'
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: 'black',
      fontSize: isMobile ? '1rem' : '1.1rem',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      padding: '8px 15px',
      borderRadius: '20px',
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
      transition: 'all 0.3s ease'
    },
    mainContent: {
      flex: '1',
      padding: isMobile ? '20px' : '40px',
      maxWidth: '900px',
      margin: '0 auto',
      width: '100%',
      boxSizing: 'border-box'
    },
    pageCard: {
      background: 'white',
      borderRadius: '20px',
      padding: isMobile ? '25px' : '40px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      marginBottom: '30px'
    },
    pageTitle: {
      color: '#333',
      fontSize: isMobile ? '2rem' : '2.5rem',
      marginBottom: '30px',
      textAlign: 'center',
      fontWeight: 700,
      borderBottom: '3px solid #ffeb3b',
      paddingBottom: '15px'
    },
    section: {
      marginBottom: '30px'
    },
    sectionTitle: {
      color: '#444',
      fontSize: isMobile ? '1.3rem' : '1.5rem',
      marginBottom: '15px',
      fontWeight: 600
    },
    paragraph: {
      color: '#666',
      fontSize: isMobile ? '0.95rem' : '1rem',
      lineHeight: '1.8',
      marginBottom: '15px',
      textAlign: 'justify'
    },
    list: {
      paddingLeft: '20px',
      marginBottom: '15px'
    },
    listItem: {
      color: '#666',
      fontSize: isMobile ? '0.95rem' : '1rem',
      lineHeight: '1.8',
      marginBottom: '10px'
    },
    lastUpdated: {
      marginTop: '30px',
      padding: '15px',
      background: '#f8f9fa',
      borderRadius: '10px',
      color: '#999',
      fontSize: isMobile ? '0.85rem' : '0.9rem',
      textAlign: 'center',
      fontStyle: 'italic'
    },
    footer: {
      background: '#fff9c4',
      color: 'black',
      padding: isMobile ? '15px 20px' : '25px 40px',
      textAlign: 'center',
      marginTop: '40px',
      width: '100%',
      boxSizing: 'border-box'
    },
    footerText: {
      margin: '0 0 10px 0',
      opacity: '0.9',
      fontSize: isMobile ? '0.8rem' : '0.95rem'
    },
    footerLinks: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: isMobile ? '15px' : '25px'
    },
    footerLink: {
      color: 'black',
      textDecoration: 'none',
      opacity: '0.8',
      transition: 'opacity 0.3s ease',
      fontSize: isMobile ? '0.8rem' : '0.9rem'
    }
  };

  return (
    <div style={styles.container} className={fontConfig.className} lang={currentLanguage}>
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.logoContainer}>
            <Link to="/" style={styles.logoLink}>
              <img src={logo} alt="Logo" style={styles.logoImage} />
            </Link>
          </div>
          <button 
            onClick={handleBack} 
            style={styles.backButton}
            onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.5)'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'}
          >
            <FaHome /> {t('home', 'Home')}
          </button>
        </div>
      </header>

      <main style={styles.mainContent}>
        <div style={styles.pageCard}>
          <h1 style={styles.pageTitle}>
            {t('termsOfService', 'Terms of Service')}
          </h1>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>
              {t('agreement', 'Agreement to Terms')}
            </h2>
            <p style={styles.paragraph}>
              {t('termsIntro', 
                'By accessing or using the Rajdoot Explorations website and services, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the service.')}
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>
              {t('description', 'Description of Service')}
            </h2>
            <p style={styles.paragraph}>
              {t('serviceDesc', 
                'Rajdoot Explorations provides a bus management platform that allows users to search for buses, view routes, and access information about bus operators. The service includes both user-facing features and administrative management tools.')}
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>
              {t('userAccounts', 'User Accounts')}
            </h2>
            <p style={styles.paragraph}>
              {t('accountsText', 'When you create an account with us, you must provide accurate, complete, and current information. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account. You are responsible for safeguarding the password and for all activities under your account.')}
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>
              {t('intellectualProperty', 'Intellectual Property')}
            </h2>
            <p style={styles.paragraph}>
              {t('ipText', 'The Service and its original content, features, and functionality are and will remain the exclusive property of Rajdoot Explorations and its licensors. The Service is protected by copyright, trademark, and other laws. Our trademarks and trade dress may not be used in connection with any product or service without prior written consent.')}
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>
              {t('userObligations', 'User Obligations')}
            </h2>
            <p style={styles.paragraph}>
              {t('obligationsText', 'As a user of our Service, you agree not to:')}
            </p>
            <ul style={styles.list}>
              <li style={styles.listItem}>• {t('obligation1', 'Use the Service in any way that violates applicable laws or regulations')}</li>
              <li style={styles.listItem}>• {t('obligation2', 'Impersonate any person or entity or falsely state your affiliation')}</li>
              <li style={styles.listItem}>• {t('obligation3', 'Interfere with or disrupt the Service or servers/networks connected to the Service')}</li>
              <li style={styles.listItem}>• {t('obligation4', 'Attempt to gain unauthorized access to any part of the Service')}</li>
              <li style={styles.listItem}>• {t('obligation5', 'Use the Service for any commercial purpose without our express consent')}</li>
            </ul>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>
              {t('termination', 'Termination')}
            </h2>
            <p style={styles.paragraph}>
              {t('terminationText', 'We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will cease immediately.')}
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>
              {t('limitationLiability', 'Limitation of Liability')}
            </h2>
            <p style={styles.paragraph}>
              {t('liabilityText', 'In no event shall Rajdoot Explorations, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.')}
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>
              {t('governingLaw', 'Governing Law')}
            </h2>
            <p style={styles.paragraph}>
              {t('lawText', 'These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict of law provisions. Any disputes arising under or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in Indore, Madhya Pradesh.')}
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>
              {t('changesTerms', 'Changes to Terms')}
            </h2>
            <p style={styles.paragraph}>
              {t('changesText', 'We reserve the right to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days\' notice prior to any new terms taking effect. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.')}
            </p>
          </div>

          <div style={styles.lastUpdated}>
            {t('lastUpdated', 'Last Updated')}: {new Date().toLocaleDateString()}
          </div>
        </div>
      </main>

      <footer style={styles.footer}>
        <p style={styles.footerText}>
          © {new Date().getFullYear()} {t('companyName', 'Rajdoot Explorations')}. {t('allRightsReserved', 'All rights reserved.')}
        </p>
        <div style={styles.footerLinks}>
          <Link to="/privacy" style={styles.footerLink}>{t('privacyPolicy', 'Privacy Policy')}</Link>
          <Link to="/terms" style={styles.footerLink}>{t('termsOfService', 'Terms of Service')}</Link>
          <Link to="/contact" style={styles.footerLink}>{t('contactUs', 'Contact Us')}</Link>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;